import { makeAutoObservable } from 'mobx'

export type SingleServiceDrawerModes =
  | 'default'
  | 'status'
  | 'dealer'
  | 'comments'
  | 'customer'
  | 'service-data'
  | 'to-rework'
  | 'to-impossible'
  | 'linked-request'
  | 'to-office-pending'

const withoutDefaultModes: SingleServiceDrawerModes[] = [
  'default',
  'service-data',
  'linked-request',
]

class SingleServiceRequestStore {
  isOpen = false
  mode: SingleServiceDrawerModes = 'default'
  prevModes: SingleServiceDrawerModes[] = []
  agreementNumber: string | null = null
  isRelinkConfirmationOpen = false
  toNumber: string | number | null = null
  requestId: number | string | null = null

  constructor() {
    makeAutoObservable(this)
  }

  setIsOpen = (value: boolean) => {
    this.isOpen = value

    if (!value) this.setMode('default')
  }

  setMode = (mode: SingleServiceDrawerModes) => {
    const shouldSetPrevMode = !withoutDefaultModes.includes(mode) && this.isOpen

    if (shouldSetPrevMode) {
      this.prevModes.push(this.mode)
    }

    this.mode = mode
  }

  goBack = () => {
    const prevMode = this.prevModes.pop()

    if (prevMode) this.mode = prevMode
    else this.setIsOpen(false)
  }

  setAgreementNumber = (agreementNumber: string | null) => {
    this.agreementNumber = agreementNumber
  }

  close = () => {
    this.isOpen = false
    this.mode = 'default'
  }

  setRelinkConfirmationOpen = (
    requestId: number | string | null,
    toNumber: string | null,
  ) => {
    this.requestId = requestId
    this.toNumber = toNumber
    this.isRelinkConfirmationOpen = true
  }

  closeRelinkConfirmation = () => {
    this.isRelinkConfirmationOpen = false
  }

  resetLinkConfirmation = () => {
    this.toNumber = null
    this.requestId = null
  }
}

export const singleServiceStore = new SingleServiceRequestStore()
